const ACCESS_TOKEN = 'access_token'
const CURRENT_STEP = 'current_step'

export class LocalStorageService {
  static setAccessToken = accessToken => localStorage.setItem(ACCESS_TOKEN, accessToken)

  static getAccessToken = () => localStorage.getItem(ACCESS_TOKEN)

  static removeAccessToken = () => localStorage.removeItem(ACCESS_TOKEN)

  static setCurrentStep = step => localStorage.setItem(CURRENT_STEP, step)
  static getCurrentStep = () => localStorage.getItem(CURRENT_STEP)
  static removeCurrentStep = () => localStorage.removeItem(CURRENT_STEP)
}
